function isValidEmail(email: string): boolean {
  return new RegExp(AppSettings.EMAIL_VALIDATION).test(email);
}

export default isValidEmail;
